/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormattedMessage } from 'react-intl';

// import * as AppPropTypes from '../../../../lib/PropTypes';
import styles from '../../../../../styles/themes/defis/displays/welcome-step.module.scss';

import PDF from '../../../../../pdf/DefisGuideNew.pdf';

const propTypes = {
    // page: AppPropTypes.page,
};

const defaultProps = {
    // page: null,
};

function WelcomeStep() {
    // const { handle = null } = page || {};
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                <FormattedMessage
                    defaultMessage="Welcome the Défis littéraires Radio-Canada!"
                    description="Display title"
                />
            </h1>
            <p className={styles.text}>
                <FormattedMessage
                    defaultMessage="To start the game, follow these steps:"
                    description="Display text"
                />
            </p>
            <ol className={styles.list}>
                <li className={styles.listItem}>
                    <h4 className={styles.subtitle}>
                        <FormattedMessage
                            defaultMessage="1. Pick the right challenge"
                            description="Display text"
                        />
                    </h4>
                    <p className={styles.description}>
                        <FormattedMessage
                            defaultMessage="Select a date and pick your current game."
                            description="Display text"
                        />
                    </p>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.subtitle}>
                        <FormattedMessage
                            defaultMessage="2. Show the PIN"
                            description="Display text"
                        />
                    </h4>
                    <p className={styles.description}>
                        <FormattedMessage
                            defaultMessage="A few minutes before the challenge, show the PIN to the participants."
                            description="Display text"
                        />
                    </p>
                </li>
                <li className={styles.listItem}>
                    <h4 className={styles.subtitle}>
                        <FormattedMessage
                            defaultMessage="3. Start the challenge"
                            description="Display text"
                        />
                    </h4>
                    <p className={styles.description}>
                        <FormattedMessage
                            defaultMessage="There'a time limit to answer the questions. The faster you answer, the more points you get. The leaderboard can be shown between questions."
                            description="Display text"
                        />
                    </p>
                </li>
            </ol>
            <p className={styles.text}>
                <FormattedMessage
                    defaultMessage="Have a good animation!"
                    description="Display text"
                />
            </p>
            <a href={PDF} target="_blank" rel="noopener noreferrer">
                <FormattedMessage
                    defaultMessage="Animator guide (PDF)"
                    description="Display text"
                />
            </a>
        </div>
    );
}

WelcomeStep.propTypes = propTypes;
WelcomeStep.defaultProps = defaultProps;

export default WelcomeStep;
